// src/components/FirebaseMessaging/index.tsx
import { useFirebaseMessaging } from '@/hooks/useFirebaseMessaging';
import React from 'react';

/**
 * Component để setup Firebase Messaging listener
 * Component này sẽ tự động lắng nghe notifications khi app đang mở
 */
const FirebaseMessaging: React.FC = () => {
  useFirebaseMessaging();
  return null; // Component không render gì
};

export default FirebaseMessaging;
